import type { IOrderPositionDTOData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';
import { useCartStateSelector } from './useCartStateSelector';

export function useCartPositionsWithBlockedState() {
  const positionsWithBlockedState = useCartStateSelector(state => {
    const order = state?.context?.currentOrder;
    if (!order) return [] as IOrderPositionDTOData[];
    const normal = order.normalPositions ?? [];
    const profitPlus = order.profitPlusPositions ?? [];
    return [...normal, ...profitPlus].flatMap(
      g => g.positions?.filter(p => p.state?.startsWith('BLOCKED_')) ?? []
    );
  });

  const blockedPositionsOrderEndTimeExeeded = positionsWithBlockedState.filter(
    p => p.state === 'BLOCKED_ORDER_END_TIME_EXCEEDED'
  );
  const blockedPositionsNotAvailable = positionsWithBlockedState.filter(p => p.state === 'BLOCKED_NOT_AVAILABLE');
  const blockedPositionsOtherReasons = positionsWithBlockedState.filter(
    p => p.state !== 'BLOCKED_ORDER_END_TIME_EXCEEDED' && p.state !== 'BLOCKED_NOT_AVAILABLE'
  );

  const hasPositionsWithBlockedState = positionsWithBlockedState.length > 0;

  return {
    positionsWithBlockedState,
    blockedPositionsOrderEndTimeExeeded,
    blockedPositionsNotAvailable,
    blockedPositionsOtherReasons,
    hasPositionsWithBlockedState
  };
}
